export class ReportHTML {
    public id: number = 0;    
    public description: string = "";    
    public kind: number = 0;
    public html: string = "";    
  
    constructor(reportHtmlType?: any) {
      // used for assign type to instance of object
      if (reportHtmlType) {
        Object.assign(this, reportHtmlType);
      }
    }
  }
  